module.exports = __webpack_public_path__ + "static/media/img--1456x800.58c248ea.58c248ea.jpg";